import type { SVGProps } from 'react';
const SvgVerticalAlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#vertical_align_center_svg__a)">
      <path
        fill="currentColor"
        d="M8 19h3v4h2v-4h3l-4-4-4 4Zm8-14h-3V1h-2v4H8l4 4 4-4ZM4 11v2h16v-2H4Z"
      />
    </g>
    <defs>
      <clipPath id="vertical_align_center_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVerticalAlignCenter;
